// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xQtQ","select":"styles_select__1yMeF"};